import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import SpanishFile from '../locales/es.json'

i18n
  .use(LanguageDetector) // Detects browser language
  .use(initReactI18next) // Passes i18n to React
  .init({
    supportedLngs: ['es'],
    fallbackLng: 'es',
    defaultLocale: 'es',
    debug: true,
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
    resources: {
      es: {
        translation: SpanishFile,
      }
    },
  });

export default i18n;